<div class="spinner-overlay">
  <p-progressSpinner styleClass="rw-spinner"></p-progressSpinner>
</div>